module.exports = __webpack_public_path__ + "img/webhook-w.a1bec6b4.svg";